import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Input, Divider } from 'semantic-ui-react';
import _ from 'lodash';

import { SingleSelect } from '../Select';
import { DeleteBtn, PlusBtn } from '../../../Buttons';
import { AddableEmptyMessage } from '../EmptyMessage';
import ErrorMessage from '../ErrorMessage';
import Required from '../Required';

export class AddableSimple extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tipo: props.types ? props.types[0] : '',
      items: props.elements || [],
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.elements !== this.props.elements) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ items: this.props.elements });
    }
  }

  onInputDelete = (item) => {
    const items = _.cloneDeep(this.state.items);
    _.remove(items, (i) => i.nome === item.nome);
    this.setState({ items });
    this.props.onChange(this.props.type, items);
  };

  onInputChange = (e, item) => {
    const items = [].concat(this.state.items);
    const index = _.findIndex(items, { key: item.key });
    items.splice(index, 1, { ...item, nome: e.target.value });
    this.setState({ items });
  };

  onChangeSelect = (data, item) => {
    const items = _.cloneDeep(this.state.items);
    const index = _.findIndex(items, { key: item.key });
    items.splice(index, 1, { ...item, tipo: data.value });
    this.setState({ items });
    this.props.onChange(this.props.type, items);
  };

  renderInput = (e) => {
    e.preventDefault();
    const items = _.cloneDeep(this.state.items);
    items.unshift({
      tipo: this.state.tipo,
      nome: this.state.input,
      key: Date.now(),
    });
    this.setState({ items });
  };

  render() {
    const {
      disabled,
      disableDelete,
      errors,
      hideSelect,
      label,
      placeholder,
      onChange,
      required,
      touched,
      type,
      types,
    } = this.props;

    const selectGridStyle = {
      textAlign: 'left',
    };
    let inputGridWidth = disableDelete ? 10 : 9;

    if (hideSelect) {
      selectGridStyle.display = 'none';
      inputGridWidth = disableDelete ? 16 : 14;
    }

    return (
      <div>
        <Grid>
          <Grid.Column width={16}>
            <Divider horizontal style={{ marginBottom: 5 }}>
              {label}
              {!disabled && [<Required required={required} />, <PlusBtn action={this.renderInput} />]}
            </Divider>
          </Grid.Column>
          {touched[type] && errors[type] && (
            <Grid.Column width={16} style={{ marginTop: -15 }}>
              <ErrorMessage centered>{errors[type]}</ErrorMessage>
            </Grid.Column>
          )}
          {(!this.state.items || this.state.items.length === 0) && (
            <Grid.Column width={16} style={{ marginTop: -15 }}>
              <AddableEmptyMessage />
            </Grid.Column>
          )}
        </Grid>
        {this.state.items.map((item) => (
          <Grid key={item.key} style={{ marginTop: 0, marginBottom: 0 }}>
            <Grid.Column style={selectGridStyle} width={disableDelete ? 6 : 5}>
              <SingleSelect
                options={types.map((value) => ({ value, label: _.startCase(value) }))}
                value={item.tipo ? item.tipo : this.state.tipo}
                onChange={(e, data) => this.onChangeSelect(data || '', item)}
                onBlur={() => {}}
                error={null}
                touched={false}
                isDisabled={disabled}
              />
            </Grid.Column>
            <Grid.Column width={inputGridWidth}>
              <Input
                value={item.nome ? item.nome : ''}
                placeholder={placeholder}
                fluid
                onChange={(e) => this.onInputChange(e, item)}
                onBlur={() => onChange(type, this.state.items)}
                disabled={disabled}
              />
            </Grid.Column>
            {!disableDelete && (
              <Grid.Column width={2} textAlign="center">
                <DeleteBtn disabled={disableDelete} action={() => this.onInputDelete(item)} />
              </Grid.Column>
            )}
          </Grid>
        ))}
      </div>
    );
  }
}

AddableSimple.propTypes = {
  placeholder: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  elements: PropTypes.array,
  onChange: PropTypes.func,
  types: PropTypes.array,
  hideSelect: PropTypes.bool,
  required: PropTypes.bool,
  touched: PropTypes.object,
  errors: PropTypes.object,
  disableDelete: PropTypes.bool,
  disabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./app/components/Forms/UI/AddableSimple/index.js